import { HTMLAttributes, forwardRef } from 'react';
import './Container.css';

export type ContainerSize = 'sm' | 'md' | 'lg' | 'xl' | 'full';

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  /** Maximum width of the container */
  size?: ContainerSize;
  /** Center the container horizontally */
  centered?: boolean;
}

/**
 * Container component for constraining content width.
 *
 * @example
 * ```tsx
 * <Container size="lg">
 *   <h1>Page content</h1>
 * </Container>
 * ```
 */
export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  (
    { size = 'lg', centered = true, className = '', children, ...props },
    ref
  ) => {
    const classNames = [
      'ui-container',
      `ui-container--${size}`,
      centered && 'ui-container--centered',
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <div ref={ref} className={classNames} {...props}>
        {children}
      </div>
    );
  }
);

Container.displayName = 'Container';
